module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis15-03b42fb25d6c9ed02b916f3680e32a61.jpg";